<template>
  <el-drawer
    title="次卡紀錄詳情"
    :visible.sync="syncShow"
    :append-to-body="true"
    destroy-on-close
    size="600px"
    class="classTicket-record-detail"
    @close="$emit('close')"
  >
    <div style="padding: 20px">
      <PunchCardInfoBlock :data="selectPunchCard" />
      <PunchCardUseBlock v-if="showEditBlock" :data="selectPunchCard" @refresh="refresh" />
      <PunchCardAddBlock v-if="showEditBlock" :data="selectPunchCard" @refresh="refresh" />
      <PunchCardUsageLogBlock :data="selectPunchCard" />
    </div>
  </el-drawer>
</template>

<script>
import { defineComponent, computed } from 'vue'
import PunchCardInfoBlock from './PunchCardInfoBlock.vue'
import PunchCardUseBlock from './PunchCardUseBlock.vue'
import PunchCardAddBlock from './PunchCardAddBlock.vue'
import PunchCardUsageLogBlock from './PunchCardUsageLogBlock.vue'
import { get } from 'lodash'

export default defineComponent({
  name: 'PunchCardRecordDetail',
  components: {
    PunchCardInfoBlock,
    PunchCardUseBlock,
    PunchCardAddBlock,
    PunchCardUsageLogBlock,
  },
  props: {
    show: Boolean,
    selectPunchCard: Object,
  },
  setup (props, { emit }) {
    const showEditBlock = computed(() => get(props.selectPunchCard, 'status') === 'available')
    const refresh = () => {
      emit('refresh')
    }
    return { refresh, showEditBlock }
  },
  computed: {
    syncShow: {
      get () {
        return this.show
      },
      set (data) {
        this.$emit('opend:show', data)
      },
    },
  },
})
</script>

<style lang="postcss" scoped>
::v-deep .el-form-item {
@apply mb-0;
}

.section-block-title {
@apply text-primary-100 font-medium text-[18px] pb-[12px];
}
::v-deep .el-drawer__header {
@apply mb-0;
}

</style>
